import { render, staticRenderFns } from "./delComment.vue?vue&type=template&id=1f44a592&scoped=true&"
import script from "./delComment.vue?vue&type=script&lang=js&"
export * from "./delComment.vue?vue&type=script&lang=js&"
import style0 from "./delComment.vue?vue&type=style&index=0&id=1f44a592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f44a592",
  null
  
)

export default component.exports